import * as RadixSwitch from '@radix-ui/react-switch';

import { cn } from '../lib/cn';

interface ISwitchProps {
  checked: boolean;
  onCheckedChange: (next: boolean) => void;
  size?: 'md' | 'sm';
  disabled?: boolean;
  id?: string;
  onBlur?: () => void;
  'aria-label'?: string;
  'aria-describedby'?: string;
  className?: string;
}

export const Switch = ({
  checked,
  onCheckedChange,
  size = 'md',
  disabled,
  className,
  ...rest
}: ISwitchProps) => {
  const md = size === 'md';

  return (
    <RadixSwitch.Root
      checked={checked}
      onCheckedChange={onCheckedChange}
      disabled={disabled}
      className={cn(
        'relative shrink-0 rounded-full border',
        md ? 'h-switch-h w-switch' : 'h-switch-sm-h w-switch-sm',
        checked ? 'border-accent bg-accent' : 'border-suppressed bg-transparent',
        disabled && 'opacity-50',
        className,
      )}
      {...rest}
    >
      <RadixSwitch.Thumb
        className={cn(
          'absolute top-hair block rounded-full',
          md ? 'size-knob' : 'size-knob-sm',
          checked ? 'right-hair bg-surface' : 'left-hair bg-faint',
        )}
      />
    </RadixSwitch.Root>
  );
};
